import APIClient from '@/shared/http/clients/api'

const resourceName = 'EtapaServico'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetEtapaServico = (aprId, revisao, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetEtapaServico/${aprId}/${revisao}`, data, config)

const aprTemplateStageServiceRepository = {
  GetEtapaServico
}

export default aprTemplateStageServiceRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprTemplateStageServiceRepository.js